<template>
  <v-footer color="primary" app elevation="5">
    <slot />
  </v-footer>
</template>
